import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootState } from '../../../index';

export const useSelect: TypedUseSelectorHook<RootState> = useSelector;
